import React from 'react'
import { Wrap } from './style.css'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

const Detail = ({ onToggle, node }) => {
  const dateParser = aDate => {
    const parsedDate = Date.parse(aDate)
    return format(parsedDate, 'dd MMMM yyyy', { locale: es })
  }

  const {
    comuna,
    estadoDeLaCausa,
    fecha,
    formalizados,
    latitud,
    longitud,
    polic_aACargo,
    rit,
    ruc,
    sector,
    semester,
    tribunal,
    year,
    delitos,
    regi_n,
  } = node
  const handleClick = () => {
    console.log('handleClick inside', node)
    onToggle()
  }
  return (
    <Wrap className="font-inter">
      {delitos && (
        <>
          <header className="px-6 py-4 ">
            <h4 className="text-2xl text-grisnegro">
              {delitos}
              <small className="block text-sm text-grisclaro">
                {dateParser(fecha)}
              </small>
              <small className="block text-sm text-grisclaro">{rit}</small>
              <small className="block text-sm text-grisclaro">{ruc}</small>
              <small className="block text-sm text-grisnegro ">
                {comuna}, {regi_n}
              </small>
              <small className="block text-sm text-grisclaro">{sector}</small>
            </h4>
          </header>
          <hr />
        </>
      )}
      <div className="px-6 py-4 ">
        {estadoDeLaCausa && (
          <h4>
            Estado: <strong>{estadoDeLaCausa}</strong>
          </h4>
        )}
        {formalizados && (
          <h4>
            Formalizados: <strong>{formalizados}</strong>
          </h4>
        )}
        {polic_aACargo && (
          <h4>
            Policía a cargo: <strong>{polic_aACargo}</strong>
          </h4>
        )}
        {tribunal && (
          <h4>
            Tribunal: <strong>{tribunal}</strong>
          </h4>
        )}
      </div>
      <hr />
      <div className="px-6 py-4 ">
        <button
          className="inline-block px-6 py-2 text-white transition-all duration-500 ease-in-out bg-gray-800 border-gray-500 rounded-full focus:outline-none hover:bg-gray-500"
          onClick={handleClick}>
          volver
        </button>
      </div>
    </Wrap>
  )
}

export default Detail
